import './HistoryItem.scss';

interface HistoryAuthor {
    login?: string;
    [key: string]: unknown;
}

interface HistoryItemProps {
    author?: HistoryAuthor;
    editor?: HistoryAuthor;
    comment?: string | string[];
    timestamp?: string | number;
}

const HistoryItem = ({ author, editor, comment, timestamp }: HistoryItemProps) => {
    return (
        <div className="history-item">
            <div className="history-item__info">
                {author?.login && (
                    <p className="history-item__text-label">
                        {author.login}
                    </p>
                )}
                {editor?.login && (
                    <p className="history-item__text-label">
                        {editor.login}
                    </p>
                )}
                {Array.isArray(comment) ? (
                    comment.map((el, i) => (
                        <p className="history-item__text-value" key={i}>
                            {el}
                        </p>
                    ))
                ) : (
                    <p className="history-item__text-value">
                        {comment}
                    </p>
                )}
            </div>

            {timestamp && (
                <p className="history-item__text-date">
                    {new Date(timestamp).toLocaleDateString(
                        'ru-RU',
                        {
                            day: '2-digit',
                            month: '2-digit',
                            year: '2-digit',
                            hour: 'numeric',
                            minute: 'numeric',
                        }
                    )}
                </p>
            )}
        </div>
    );
};

export { HistoryItem };